export default __webpack_public_path__ + "static/media/main-tab-arrow.d8dabce5.svg";